import React, { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

interface LoaderProps {
    open: boolean,
    onClick: () => void,
}

//
export default function Loader(props: LoaderProps): JSX.Element {
    //
    return (
        <div>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => {
                        return theme.zIndex.drawer + 1
                    }
                }}
                { ...props }
            >
                <CircularProgress
                    color="primary"
                    size={100}
                />
            </Backdrop>
        </div>
    );
}